import { useEffect, useState } from "react";
import moment from "moment";

const countdownHandler = (start_time_tracked) => {
  if (!!!start_time_tracked) return "00:00:00";

  const msLeft = moment().diff(moment(start_time_tracked));
  const duration = moment.duration(msLeft);

  const hours = Math.floor(duration.asMinutes() / 60);
  const minutes = Math.floor(duration.asMinutes() % 60);
  const seconds = Math.floor((duration.asMinutes() * 60) % 60);

  let formattedHours = String(hours).padStart(2, "0");
  let formattedMinutes = String(minutes).padStart(2, "0");
  let formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

const TrackerButtonTimer = ({ start_time_tracked }) => {
  const [countdown, setCountdown] = useState(
    countdownHandler(start_time_tracked)
  );

  useEffect(() => {
    var interval = setInterval(() => {
      setCountdown(countdownHandler(start_time_tracked));
    }, 1000);

    setCountdown(countdownHandler(start_time_tracked));

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [start_time_tracked]);

  return countdown;
};

export default TrackerButtonTimer;
